module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.pageTitle) + "\n  ")]), _vm._v(" "), (_vm.isLogin == false) ? _c('div', {
    staticClass: "login-part"
  }, [_c('p', {
    staticClass: "login-in"
  }, [_c('group', [_c('x-input', {
    attrs: {
      "title": "用户名"
    },
    model: {
      value: (_vm.accountsVal),
      callback: function($$v) {
        _vm.accountsVal = $$v
      },
      expression: "accountsVal"
    }
  }, [_c('img', {
    staticClass: "img-user",
    staticStyle: {
      "padding-right": "10px",
      "display": "block"
    },
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/user.png"),
      "width": "24",
      "height": "24"
    },
    slot: "label"
  })])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "login-in"
  }, [_c('group', [_c('x-input', {
    attrs: {
      "title": "密码"
    },
    model: {
      value: (_vm.passwordVal),
      callback: function($$v) {
        _vm.passwordVal = $$v
      },
      expression: "passwordVal"
    }
  }, [_c('img', {
    staticClass: "img-lock",
    staticStyle: {
      "padding-right": "10px",
      "display": "block"
    },
    attrs: {
      "slot": "label",
      "src": require("../assets/icon/lock.png"),
      "width": "24",
      "height": "24"
    },
    slot: "label"
  })])], 1)], 1), _vm._v(" "), _c('p', [_c('x-button', {
    staticClass: "login-button",
    attrs: {
      "action-type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goLogin($event)
      }
    }
  }, [_vm._v("登 录")])], 1), _vm._v(" "), _c('p', {
    staticClass: "register-part"
  }, [_vm._v("\n      还没有账号，\n      "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("\n        去注册\n      ")])], 1)]) : _c('div', {
    staticClass: "logout-part"
  }, [_c('p', [_c('x-button', {
    staticClass: "logout-button",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goLogout($event)
      }
    }
  }, [_vm._v("解除绑定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e154e0e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Login.vue
// module id = Gaow
// module chunks = 0